import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Card from "react-bootstrap/Card";
import classNames from "classnames";
import { Table } from "@dpdgroupuk/mydpd-ui";
import Error from "../Error";
import { Address } from "../types";
import { formatAddress } from "./models";
import "./styles.scss";

const ResultsPanel = ({
  addresses,
  error,
  onSelect
}) => {
  const scrollableContainerRef = React.useRef(null);
  const columns = [{
    render: ({
      rowData
    }) => formatAddress(rowData)
  }]; // Scroll to top if search items have been changed

  useEffect(() => {
    if (scrollableContainerRef && scrollableContainerRef.current) {
      scrollableContainerRef.current.scrollTop = 0;
    }
  }, [addresses]);
  return /*#__PURE__*/React.createElement(Card, {
    className: "results-panel"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: "results-title"
  }, "Results", /*#__PURE__*/React.createElement("span", {
    className: classNames("results-count", !error && !addresses.length && "results-count-warning", error && "results-count-error")
  }, addresses.length)), /*#__PURE__*/React.createElement("div", {
    className: "results-body",
    ref: scrollableContainerRef
  }, error ? /*#__PURE__*/React.createElement(Error, null) : /*#__PURE__*/React.createElement(Table, {
    data: addresses,
    columns: columns,
    onClickRow: onSelect,
    tableContainerClassName: "result-table-container"
  })));
};

ResultsPanel.propTypes = {
  onSelect: PropTypes.func,
  error: PropTypes.string,
  addresses: PropTypes.arrayOf(PropTypes.shape(Address))
};
export default ResultsPanel;